<template>
  <div class="Home">
    <div class="nav">
      <div class="left">
        <p>Gbozo App Dashboard</p>
      </div>
      <div class="right">
        <p>{{user_name}}</p>
<!--        <img :src="user_avatar" alt="">-->
        <button @click="onLogout">Log out</button>
      </div>
    </div>
    <div class="body">
      <div class="side">
        <el-menu
            :default-active="current_index.toString()"
            class="menu"
            @select="onRouteChange"
            background-color="#2E2F32"
            text-color="#fff"
            active-text-color="#2CD5C8">
          <el-menu-item
              v-for="(route,index) in routes"
              :index="index.toString()"
              :key="route.name">
            <i :class="route.icon"></i>
            <span>{{route.name | upperCase}}</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="main">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
  import {verifyToken} from "@/utils/api";

  // require('default-passive-events');
  export default {
    props: {},
    data: () => {
      return {
        user_name: '',
        user_avatar: '',
        routes: [],
        current_index: ''
      }
    },

    beforeCreate() {

    },
    beforeMount() {
      verifyToken().then(res => {
        if (res.errcode === 0) {
          this.user_name = res.user_name;
          this.user_avatar = res.user_avatar;
          this.routes = res.routes
        } else {
          this.$message.error(res.errmsg);
          this.$router.replace('/login')
        }
      })
    },


    beforeUpdate() {
      let name = this.$route.name;
      let current_index;
      this.routes.forEach((v, i) => {
        if (v.name === name) {
          current_index = i
        }
      });
      this.current_index = current_index
    },
    beforeLeave() {
      this.$hideLoading();
    },
    methods: {

      onRouteChange(index) {
        if (this.$router.history.current.name !== this.routes[index].name) {
          this.$router.push({
            name: this.routes[index].name
          })
        }

      },
      onLogout() {
        localStorage.removeItem('token');
        this.$store.commit('delToken');
        this.$router.replace('/login');
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "_Home.scss";
</style>